import { RestClientAuthenticated } from '../network';
import { CitiesDTO } from './types/CitiesDTO';
import { CountriesDTO } from './types/CountriesDTO';
import { SingleFieldDTOString } from './types/SingleFieldDTOString';
import { InscriptionDTO } from './types/InscriptionDTO';
import { ResponseDTO } from './types/ResponseDTO';

const creationApi = {
  fecthCities: (cityPrefix: SingleFieldDTOString): Promise<CitiesDTO> => new RestClientAuthenticated('/getCitiesOnSelect', 'POST', 'application/json').jsonBody(cityPrefix).execute(),
  fetchCountries: (): Promise<CountriesDTO> => new RestClientAuthenticated('/getCountries', 'POST', 'application/json').execute(),
  signup: (inscriptionDTO: InscriptionDTO): Promise<ResponseDTO> => new RestClientAuthenticated('/inscription/signup', 'POST', 'application/json').jsonBody(inscriptionDTO).execute(),
  isUserInfoValid: (inscriptionDTO: InscriptionDTO): Promise<ResponseDTO> => new RestClientAuthenticated('/inscription/isUserInfoValid', 'POST').jsonBody(inscriptionDTO).execute(),
  isSignUpAvailable: (): Promise<{ value: boolean }> => new RestClientAuthenticated('/inscription/is-signup-available', 'GET', 'application/json').execute(),
  enrole: (inscriptionDTO: InscriptionDTO): Promise<ResponseDTO> => new RestClientAuthenticated('/enrolement/signup', 'POST', 'application/json').jsonBody(inscriptionDTO).execute(),
  validateFromEnrolement: (inscriptionDTO: InscriptionDTO): Promise<ResponseDTO> => new RestClientAuthenticated('/enrolement/isUserInfoValid', 'POST').jsonBody(inscriptionDTO).execute(),
};

export default creationApi;
